module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/popup.89d8717c.png";